import { WarningAmber } from '@mui/icons-material';
import { Alert, Typography } from '@mui/material';
import { format, subMonths } from 'date-fns';
import { Link } from 'react-router-dom';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { usePlanLimit } from 'src/context/PlanLimitContext';

const PlanLimitBanner = () => {
  const { auth } = useAuthContext();
  const { isBannerVisible, showBanner, hideBanner } = usePlanLimit();

  if (
    !isBannerVisible ||
    !auth.isLoggedIn ||
    !auth.user?.subscription?.plan?.availableDataPeriod ||
    auth?.user?.subscription?.plan?.type === 'vip'
  ) {
    return <></>;
  }

  const periodLimit = auth?.user?.subscription?.plan?.availableDataPeriod;

  return (
    <Alert
      icon={<WarningAmber color="inherit" fontSize="large" />}
      severity="warning"
      onClose={hideBanner}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        '& .MuiAlert-icon': {
          color: '#FF8211',
        },
      }}>
      <Typography fontSize={14}>
        Somente registros posteriores à&nbsp;
        <b>{format(subMonths(new Date(), periodLimit ?? 0), 'MM/yyyy')}</b>{' '}
        estão disponíveis para seu plano. Quer ver todo histórico
        disponível?&nbsp;
        <Link
          style={{
            color: 'inherit',
            fontWeight: 600,
          }}
          to="/planos">
          faça upgrade
        </Link>
        &nbsp;para o plano VIP
      </Typography>
    </Alert>
  );
};

export default PlanLimitBanner;
